export default "__VITE_ASSET__ffb3aadc__"